import { useQuery } from "@tanstack/react-query";
import type { TikTokRegion } from "@unbox/api";
import { handleError } from "@/api/error";
import { client } from "../client";

export const useAvailableTikTokShops = () => {
  return useQuery({
    queryKey: ["admin", "tiktok-shops"],
    queryFn: async () => {
      const res = await client.admin["tiktok-shops"].$get();
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
  });
};

export const useTikTokShopBrands = (s3Key: string, shopCipher: string, region: TikTokRegion) => {
  return useQuery({
    queryKey: ["admin", "tiktok-shops", "brands", s3Key, shopCipher],
    queryFn: async () => {
      const res = await client.admin["tiktok-shops"].brands.$get({
        query: { s3Key, shopCipher, region },
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    enabled: !!s3Key && !!shopCipher && !!region,
  });
};
